import React from 'react'
import Img from 'gatsby-image'
import { getFluidGatsbyImage } from 'gatsby-source-sanity'

const sanityConfig = { projectId: 'ik0lawis', dataset: 'production' }

const ImageBlock = ({ node }) => {
  const { asset, alt, caption } = node

  // If it's a gif, render using Sanity CDN
  if (asset._ref.slice(-3) == 'gif') {
    const gifID = asset._ref.slice(6, -4)
    const gifUrl = `https://cdn.sanity.io/images/${sanityConfig.projectId}/${sanityConfig.dataset}/${gifID}.gif`
    return (
      <figure className="block-image">
        <img src={gifUrl} alt={alt} />
        {caption && (
          <figcaption className="block-image-caption">{caption}</figcaption>
        )}
      </figure>
    )
  }

  // Else render as fluid Gatsby Img
  let fluidProps = getFluidGatsbyImage(
    asset._ref,
    {
      maxWidth: 1280,
    },
    sanityConfig
  )

  // Trick to set maxWeight and maxHeight equal to presentation sizes
  // to center align images and stop them from taking full container width
  // even if they are of smaller size
  let presentationWidth = fluidProps.sizes.split(' ')
  presentationWidth = parseInt(
    presentationWidth[presentationWidth.length - 1].slice(0, -2),
    10
  )

  return (
    <figure className="block-image">
      <Img
        fluid={{
          ...fluidProps,
          maxWidth: presentationWidth,
          maxHeight: fluidProps.aspectRatio * presentationWidth,
        }}
        alt={alt}
        imgStyle={{
          // width: 'auto',
          // height: 'auto',
          maxWidth: '100%',
        }}
        style={{
          margin: '0 auto',
        }}
      />
      {caption && (
        <figcaption className="block-image-caption">{caption}</figcaption>
      )}
    </figure>
  )
}

export default ImageBlock
